export function showScreenSize() {
    var h = $(window).height();
    var w = $(window).width()
    console.log('screen size = ' + w + ' x ' + h);
}